export default function CTASection() {
  return (
    <section className="relative py-24 md:py-36 flex items-center justify-center overflow-hidden min-h-[500px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Expansive%20aerial%20flat%20lay%20of%20fashion%20essentials%20radiating%20outward%20from%20center%20on%20warm%20sandstone%20surface%20bold%20graphic%20arrangement%20of%20footwear%20apparel%20and%20lifestyle%20objects%20with%20dramatic%20overhead%20lighting%20casting%20radial%20shadows%20contemporary%20editorial%20composition%20with%20rich%20earthy%20palette&width=1920&height=800&seq=cta-radial-july2026&orientation=landscape"
          alt="Superbuy Spreadsheet product collection"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/40 to-foreground-950/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 tracking-wide">
          SUPERBUY SPREADSHEET 2026
        </h2>
        <p className="text-background-50/80 text-sm md:text-base mb-2 max-w-xl mx-auto">
          The most comprehensive curated product resource updated daily
        </p>
        <p className="text-background-50/70 text-sm mb-10 max-w-xl mx-auto">
          Join thousands of smart shoppers discovering better products every day
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-900 text-background-50 rounded-full font-semibold text-sm hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap group"
        >
          <span className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-400 transition-colors">
            <i className="ri-link text-background-50 text-sm w-5 h-5 flex items-center justify-center"></i>
          </span>
          VISIT KASPREADSHEET.COM
          <i className="ri-arrow-right-up-line text-lg w-5 h-5 flex items-center justify-center"></i>
        </a>
      </div>
    </section>
  );
}